<div class="text-box-container">
  <div class="question-header">
    <h6 class="m-0 p-0"
    [style.font-size]="questionnaire?.mainContentTemplate?.questionStyle?.fontSize + 'px'"
    [style.font-family]="questionnaire?.mainContentTemplate?.questionStyle?.fontFamily"
    [style.font-weight]="questionnaire?.mainContentTemplate?.questionStyle?.boldStyle"
    [style.color]="questionnaire?.mainContentTemplate?.questionStyle?.fontColor"
    >
      {{ questionNumber }}. {{ question?.question || 'Untitled Question' | titlecase }}
      @if(question?.required) {
      <span 
      [style.font-size]="'18px'"
      [style.font-family]="questionnaire?.mainContentTemplate?.errorMessageStyle?.fontFamily"
      [style.font-weight]="questionnaire?.mainContentTemplate?.errorMessageStyle?.boldStyle"
      [style.color]="questionnaire?.mainContentTemplate?.errorMessageStyle?.fontColor"
      >*</span>
      }
    </h6>
  </div>

  <div class="question-content-opinion">
    <div class="opinion-scale">
      <!-- Labels Row -->
      @if(question?.questionSpecificOptions?.labels?.length) {
      <div
        class="labels-row"
        [ngClass]="'labels-row-width-' + getScaleArray(toNumber(scaleCount)).length"
      >
        @for(label of question?.questionSpecificOptions?.labels || []; track label) {
        <span class="rating-label"
        [style.font-size]="questionnaire?.mainContentTemplate?.choiceStyle?.fontSize + 'px'"
        [style.font-family]="questionnaire?.mainContentTemplate?.choiceStyle?.fontFamily"
        [style.font-weight]="questionnaire?.mainContentTemplate?.choiceStyle?.boldStyle"
        [style.color]="questionnaire?.mainContentTemplate?.choiceStyle?.fontColor"
        >{{ label.text | titlecase }}</span>
        }
      </div>
      }

      <!-- Buttons Row -->
      <div class="opinion-buttons">
        @for(i of getScaleArray(toNumber(scaleCount)); track i) {
        <button
          type="button"
          class="opinion-button"
          [class.text-primary]="selectedRating !== null && selectedRating >= i"
          (click)="selectRating(i, $event)"
        >
          {{ i }}
        </button>
        }
      </div>
    </div>
  </div>
</div>
